module.exports = __webpack_public_path__ + "img/bottomBg0.6e1f3ab0.png";